import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export type TPlanningFinancialField =
  | 'SellThruSumUSDNdp'
  | 'SellThruSumUSDNet'
  | 'SellThruSumUSDTNet'
  | 'SellThruSumUSDUTNet'
  | 'SellThruSumLCNdp'
  | 'SellThruSumLCNet'
  | 'SellThruSumLCTNet'
  | 'SellThruSumLCUTNet'

const USD_FIELD_BY_TYPE: Record<ActualsValueTypes, TPlanningFinancialField | null> = {
  [ActualsValueTypes.None]: null,
  [ActualsValueTypes.Ndp]: 'SellThruSumUSDNdp',
  [ActualsValueTypes.Net]: 'SellThruSumUSDNet',
  [ActualsValueTypes.TNet]: 'SellThruSumUSDTNet',
  [ActualsValueTypes.UTNet]: 'SellThruSumUSDUTNet',
}

const LC_FIELD_BY_TYPE: Record<ActualsValueTypes, TPlanningFinancialField | null> = {
  [ActualsValueTypes.None]: null,
  [ActualsValueTypes.Ndp]: 'SellThruSumLCNdp',
  [ActualsValueTypes.Net]: 'SellThruSumLCNet',
  [ActualsValueTypes.TNet]: 'SellThruSumLCTNet',
  [ActualsValueTypes.UTNet]: 'SellThruSumLCUTNet',
}

export const getPlanningFinancialField = (
  actualsType: ActualsValueTypes,
  isLocalCurrency: boolean
): TPlanningFinancialField | null =>
  (isLocalCurrency ? LC_FIELD_BY_TYPE : USD_FIELD_BY_TYPE)[actualsType]
